module.exports = __webpack_public_path__ + "static/media/tigerLogo.86d0ebad.png";